<template>
  <ul id="menu-interno">
    <li class=""><a @click="mudarSelecao('ccd-home')">Inicial</a></li>

    <li class="">Repositórios:</li>
    <li class="" style="padding-left: 15px;" v-for="(item,ref) in acs"><a @click="mudarAC(item._key)">AC {{item.nome}}</a></li>

    <li class="" style="padding-left: 15px;" v-for="(item,ref) in pscs"><a @click="mudarPSC(item._key)">PSC {{item.nome}}</a></li>

    <li class="">Informações e Serviços:</li>
    <li class="" v-for="(item,ref) in menu">&nbsp; <a @click="mudarSelecao(ref)">{{item}}</a></li>

  </ul>
</template>

<script>
import { EventBus } from '../main';

export default {
  data() {
    return {
      menu: EventBus.menu
    }
  },
  methods: {
    mudarSelecao( selecao ) {
      EventBus.$emit('mudarSelecao', selecao);
    },
    mudarAC( selecao, nivel ) {
      EventBus.$emit('mudarAC', selecao );
    },
    mudarPSC( selecao ) {
      EventBus.$emit('mudarPSC', selecao );
    }
  },
  computed: {
    acs() {
      //console.log('Computed: Menu acs');
      /**
        Preparar Array com as ACs para o v-for
      */
      const resultArray = [];
      for( let key in EventBus.acs ) {
        const item = EventBus.acs[key];
        item._key = key;
        resultArray.push( item );
      }
      return resultArray;
    },
    pscs() {
      //console.log('Computed: Menu acs');
      /**
        Preparar Array com os PSCs para o v-for
      */
      const resultArray = [];
      for( let key in EventBus.pscs ) {
        const item = EventBus.pscs[key];
        item._key = key;
        resultArray.push( item );
      }
      return resultArray;
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Menu.vue?0cb63473